/**
 * Kicks off image requests for every koyal frame as soon as the widget
 * mounts, so the first animation transition doesn't pop in on network
 * stutter. Idempotent — safe to call more than once.
 */

import { ALL_SPRITE_NAMES } from "./animations";

const preloadedBaseUrls = new Set<string>();

export function preloadAllSpriteFrames(baseUrl: string): void {
  if (preloadedBaseUrls.has(baseUrl)) return;
  preloadedBaseUrls.add(baseUrl);
  const trimmedBase = baseUrl.replace(/\/$/, "");
  ALL_SPRITE_NAMES.forEach((spriteName) => {
    const image = new Image();
    image.decoding = "async";
    image.src = `${trimmedBase}/${spriteName}.png`;
  });
}
